<template>
  
  <div :id="_uid" class="ui small modal" :class="modalSelector">
    <div class="ui header">
      Definir Filtro
    </div>
    <div class="content">
      <div class="ui form">
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Data Inicial <span class="red text">*</span></label>
            <date-picker ref="startDatePicker" :autoInit="false" @onChange="onChangeStartDate" />
          </div>                                                 
          <div class="eight wide field">
            <label class="form-label">Data Final <span class="red text">*</span></label>
            <date-picker ref="endDatePicker" :autoInit="false" @onChange="onChangeEndDate" />
          </div>   
        </div>  
        <div v-show="$isCustomer()" class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Clínica <span class="red text">*</span></label>
            <select-dropdown ref="customerDropdown" @onChange="onChangeCustomer" />
          </div>  
        </div> 
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i> Sair
      </button>            
      <button class="ui blue button" :class="{ disabled: !canApply }" @click="onApply()">
        <i class="checkmark icon"></i> Aplicar
      </button>
    </div>
  </div>

</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"
  import { DatePicker, SelectDropdown } from "@/components"

  export default {
    
    name: "CertsPieFilterModal",

    mixins: [modalDialog],

    data() {
      return {
        filter: {},
      }
    },

    components: {
      DatePicker,
      SelectDropdown,
    },

    computed: {

      canApply() {
        return (this.filter.startDate && this.filter.endDate)
      },
    },

    methods: {      

      setFilter(filter) {
        this.filter = this.$cloneObject(filter)
      },

      onShow() {
        this.emitEvent = null
        this.loadDatePickers()
        this.loadCustomerDropdown()
      }, 

      loadDatePickers() {
        
        this.$refs.startDatePicker.initCalendar({ force: true })
        this.$refs.endDatePicker.initCalendar({ force: true })

        this.$refs.startDatePicker.setDate(this.filter.startDate)
        this.$refs.endDatePicker.setDate(this.filter.endDate)
      },   

      loadCustomerDropdown() {

        if (!this.$isCustomer())
          return

        let values = []
        
        this.$store.state.auth.user.customers.forEach((customer) => {
          values.push({
            id: customer.id,
            name: customer.shortName,
          })
        })

        this.$refs.customerDropdown.setValues(values, this.filter.customerId)   
      },

      onChangeStartDate(date) {
        this.filter.startDate = date
        this.refreshData()          
      },

      onChangeEndDate(date) {
        this.filter.endDate = date
        this.refreshData()          
      },

      onChangeCustomer(id) {
        this.filter.customerId = id
        this.refreshData()
      },

      refreshData() {
        this.filter = this.$cloneObject(this.filter)
      },

      onApply() {
        
        this.emitEvent = { event: "onApply", data: this.filter }

        this.hide()        
      },
    },
  }

</script>